import { observable, action, runInAction } from 'mobx'
import remotedev from 'mobx-remotedev'
import { StoreExt } from '@utils/reactExt'

import { subscriptions } from '@services/api'

export class subscriptionsStore extends StoreExt {
    @observable loading = false
    @observable subscriptions = []

    @action
    getSubscriptions = async () => {
        this.loading = true
        try {
            const res = await subscriptions.getSubscriptions()
            runInAction(() => {
                this.subscriptions = res.data
            })
        } finally {
            runInAction(() => {
                this.loading = false
            })
        }
    }

    @action
    resetSubscriptions = () => {
        this.subscriptions = []
    }
}

export default remotedev(new subscriptionsStore())
